export enum SocialType {
    FACEBOOK = "FACEBOOK",
    LINKEDIN = "LINKEDIN",
    INSTAGRAM = "INSTAGRAM",
    TWITTER = "TWITTER"
}

export interface SocialIconProps {
    social: SocialType;
    url: string;
}